import { render, staticRenderFns } from "./nhiaDialog.vue?vue&type=template&id=1794b3c2&"
import script from "./nhiaDialog.vue?vue&type=script&lang=js&"
export * from "./nhiaDialog.vue?vue&type=script&lang=js&"
import style0 from "./nhiaDialog.vue?vue&type=style&index=0&id=1794b3c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports